import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { Box, Text, Hide } from 'roo-ui/components';
import PointsEarnDisplay from 'components/PointsEarnDisplay';
import { Flag } from 'pages/Property/PropertyAvailability/RoomTypes/primitives';
import BusinessRewardsModal from './BusinessRewardsModal';
import BusinessRewardsTooltip from './BusinessRewardsTooltip';

const OfferPointsEarn = React.memo(({ pointsEarned, isClassic }) => {
  const qffPoints = get(pointsEarned, 'qffPoints');
  const qbrPoints = get(pointsEarned, 'qbrPoints');

  return (
    <Box color="greys.steel">
      <Flag icon="roo">
        {!isClassic && (
          <Fragment>
            <Text display="block" fontSize="base">
              Earn <PointsEarnDisplay {...qffPoints} /> Points^
            </Text>
            <Hide md lg>
              <BusinessRewardsModal qbrPoints={qbrPoints} />
            </Hide>
            <Hide sm xs>
              <BusinessRewardsTooltip qbrPoints={qbrPoints} />
            </Hide>
          </Fragment>
        )}
        {isClassic && <Text display="block">You will not earn Qantas Points on Classic Rewards offers</Text>}
      </Flag>
    </Box>
  );
});

OfferPointsEarn.propTypes = {
  pointsEarned: PropTypes.object.isRequired,
  isClassic: PropTypes.bool,
  inclusions: PropTypes.array,
};

OfferPointsEarn.defaultProps = {
  inclusions: [],
  isClassic: false,
};

OfferPointsEarn.displayName = 'OfferPointsEarn';

export default OfferPointsEarn;
